// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contacts-app {
  position: relative;
  display: flex;
  height: 100%;
  width: 100%;
  background: var(--theme-bg-primary);
  color: var(--theme-text-primary);
  overflow: hidden;
}
.contacts-app--loading, .contacts-app--error {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-md);
  color: var(--theme-text-secondary);
}
.contacts-app__spinner {
  width: 28px;
  height: 28px;
  border: 3px solid var(--theme-border-primary);
  border-top-color: var(--theme-primary);
  border-radius: 50%;
  animation: contacts-spin 0.8s linear infinite;
}
.contacts-app__sidebar {
  width: 230px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  background: var(--theme-sidebar-bg);
  border-right: 1px solid var(--theme-sidebar-border);
  padding: var(--space-md) 0 var(--space-sm);
}
.contacts-app__sidebar-header {
  display: flex;
  align-items: center;
  gap: var(--space-sm);
  padding: 0 var(--space-md) var(--space-md);
  font-size: var(--font-size-sm);
  font-weight: var(--font-weight-semibold);
  color: var(--theme-text-tertiary);
  text-transform: uppercase;
  letter-spacing: 0.5px;
}
.contacts-app__nav {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  padding: 0 var(--space-xs);
  gap: 1px;
}
.contacts-app__nav-item {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-sm);
  padding: 9px 10px;
  border-radius: var(--radius-md);
  border: none;
  background: transparent;
  color: var(--theme-text-secondary);
  font-size: var(--font-size-base);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  text-align: left;
  transition: background 0.12s, color 0.12s;
}
.contacts-app__nav-item svg {
  flex-shrink: 0;
  opacity: 0.7;
  transition: opacity 0.12s;
}
.contacts-app__nav-item:hover {
  background: var(--theme-sidebar-hover);
  color: var(--theme-text-primary);
}
.contacts-app__nav-item:hover svg {
  opacity: 1;
}
.contacts-app__nav-item--active {
  background: var(--theme-selected-bg);
  color: var(--theme-primary);
  font-weight: var(--font-weight-semibold);
}
.contacts-app__nav-item--active svg {
  opacity: 1;
  color: var(--theme-primary);
}
.contacts-app__nav-item--active:hover {
  background: var(--theme-primary-soft-hover);
}
.contacts-app__sidebar-actions {
  display: flex;
  flex-direction: column;
  gap: var(--space-sm);
  padding: var(--space-md) var(--space-md) var(--space-xs);
  margin-top: var(--space-sm);
  border-top: 1px solid var(--theme-border-soft);
}
.contacts-app__action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: var(--space-xs);
  padding: 7px 12px;
  border-radius: var(--radius-md);
  border: 1px solid transparent;
  background: transparent;
  color: var(--theme-text-secondary);
  font-size: var(--font-size-md);
  font-weight: var(--font-weight-medium);
  cursor: pointer;
  transition: background 0.15s, color 0.15s, box-shadow 0.15s, transform 0.15s;
  width: 100%;
}
.contacts-app__action-btn:hover:not(:disabled) {
  background: var(--theme-sidebar-hover);
  color: var(--theme-text-primary);
}
.contacts-app__action-btn--primary {
  background: var(--theme-primary);
  color: var(--theme-primary-contrast);
  border-color: transparent;
  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.3), 0 1px 2px rgba(37, 99, 235, 0.2);
  font-weight: var(--font-weight-semibold);
}
.contacts-app__action-btn--primary:hover:not(:disabled) {
  background: var(--theme-primary-hover);
  box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4), 0 2px 4px rgba(37, 99, 235, 0.25);
  transform: translateY(-1px);
}
.contacts-app__action-btn--primary:active {
  transform: translateY(0);
  box-shadow: 0 1px 3px rgba(37, 99, 235, 0.3);
}
.contacts-app__action-btn--loading, .contacts-app__action-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none !important;
}
.contacts-app__import-result {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px var(--space-xs);
  font-size: var(--font-size-xs);
  color: var(--theme-success);
  flex-wrap: wrap;
}
.contacts-app__import-error {
  padding: 4px var(--space-xs);
  font-size: var(--font-size-xs);
  color: var(--theme-danger);
  word-break: break-word;
}
.contacts-app__list-panel {
  width: 280px;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
  border-right: 1px solid var(--theme-border-soft);
  background: var(--theme-bg-primary);
}
.contacts-app__search {
  position: relative;
  padding: var(--space-sm) var(--space-md);
  border-bottom: 1px solid var(--theme-border-soft);
}
.contacts-app__search-icon {
  position: absolute;
  left: calc(var(--space-md) + 8px);
  top: 50%;
  transform: translateY(-50%);
  color: var(--theme-text-muted);
  pointer-events: none;
}
.contacts-app .contacts-app__search-input {
  width: 100%;
  padding: 6px 10px 6px 28px;
  border-radius: var(--radius-md);
  border: 1px solid var(--theme-border-primary);
  background: var(--theme-bg-secondary);
  color: var(--theme-text-primary);
  font-size: var(--font-size-md);
  outline: none;
  transition: border-color 0.12s, box-shadow 0.12s;
}
.contacts-app .contacts-app__search-input::placeholder {
  color: var(--theme-text-placeholder);
}
.contacts-app .contacts-app__search-input:focus {
  border-color: var(--theme-border-focus);
  background: var(--theme-bg-primary);
  box-shadow: var(--theme-shadow-focus);
}
.contacts-app__detail-panel {
  flex: 1 1;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-width: 0;
}
.contacts-app__empty-detail {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: var(--space-md);
  color: var(--theme-text-muted);
  font-size: var(--font-size-base);
}

@keyframes contacts-spin {
  to {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/apps/ContactsApp/ContactsApp.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,aAAA;EACA,YAAA;EACA,WAAA;EACA,mCAAA;EACA,gCAAA;EACA,gBAAA;AACF;AACE;EAEE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,kCAAA;AAAJ;AAGE;EACE,WAAA;EACA,YAAA;EACA,6CAAA;EACA,sCAAA;EACA,kBAAA;EACA,6CAAA;AADJ;AAME;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,mCAAA;EACA,mDAAA;EACA,0CAAA;AAJJ;AAOE;EACE,aAAA;EACA,mBAAA;EACA,oBAAA;EACA,0CAAA;EACA,8BAAA;EACA,wCAAA;EACA,iCAAA;EACA,yBAAA;EACA,qBAAA;AALJ;AAQE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,QAAA;AANJ;AASE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,+BAAA;EACA,YAAA;EACA,uBAAA;EACA,kCAAA;EACA,gCAAA;EACA,sCAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;AAPJ;AASI;EACE,cAAA;EACA,YAAA;EACA,yBAAA;AAPN;AAUI;EACE,sCAAA;EACA,gCAAA;AARN;AAUM;EAAM,UAAA;AAPZ;AAUI;EACE,oCAAA;EACA,2BAAA;EACA,wCAAA;AARN;AAUM;EACE,UAAA;EACA,2BAAA;AARR;AAWM;EACE,2CAAA;AATR;AAgBE;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,wDAAA;EACA,2BAAA;EACA,8CAAA;AAdJ;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,iBAAA;EACA,+BAAA;EACA,6BAAA;EACA,uBAAA;EACA,kCAAA;EACA,8BAAA;EACA,sCAAA;EACA,eAAA;EACA,4EAAA;EACA,WAAA;AAfJ;AAiBI;EACE,sCAAA;EACA,gCAAA;AAfN;AAkBI;EACE,gCAAA;EACA,oCAAA;EACA,yBAAA;EACA,8EAAA;EACA,wCAAA;AAhBN;AAkBM;EACE,sCAAA;EACA,gFAAA;EACA,2BAAA;AAhBR;AAmBM;EACE,wBAAA;EACA,4CAAA;AAjBR;AAqBI;EAEE,aAAA;EACA,mBAAA;EACA,0BAAA;AApBN;AAwBE;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,4BAAA;EACA,8BAAA;EACA,2BAAA;EACA,eAAA;AAtBJ;AAyBE;EACE,4BAAA;EACA,8BAAA;EACA,0BAAA;EACA,sBAAA;AAvBJ;AA4BE;EACE,YAAA;EACA,cAAA;EACA,aAAA;EACA,sBAAA;EACA,gDAAA;EACA,mCAAA;AA1BJ;AA6BE;EACE,kBAAA;EACA,wCAAA;EACA,iDAAA;AA3BJ;AA8BE;EACE,kBAAA;EACA,iCAAA;EACA,QAAA;EACA,2BAAA;EACA,8BAAA;EACA,oBAAA;AA5BJ;AAgCE;EACE,WAAA;EACA,0BAAA;EACA,+BAAA;EACA,6CAAA;EACA,qCAAA;EACA,gCAAA;EACA,8BAAA;EACA,aAAA;EACA,gDAAA;AA9BJ;AAgCI;EACE,oCAAA;AA9BN;AAiCI;EACE,uCAAA;EACA,mCAAA;EACA,qCAAA;AA/BN;AAqCE;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;AAnCJ;AAsCE;EACE,SAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,oBAAA;EACA,8BAAA;EACA,gCAAA;AApCJ;;AAwCA;EACE;IAAK,yBAAA;EApCL;AACF","sourcesContent":[".contacts-app {\n  position: relative;\n  display: flex;\n  height: 100%;\n  width: 100%;\n  background: var(--theme-bg-primary);\n  color: var(--theme-text-primary);\n  overflow: hidden;\n\n  &--loading,\n  &--error {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: var(--space-md);\n    color: var(--theme-text-secondary);\n  }\n\n  &__spinner {\n    width: 28px;\n    height: 28px;\n    border: 3px solid var(--theme-border-primary);\n    border-top-color: var(--theme-primary);\n    border-radius: 50%;\n    animation: contacts-spin 0.8s linear infinite;\n  }\n\n  // ── Sidebar ────────────────────────────────────────────────────────────────\n\n  &__sidebar {\n    width: 230px;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    background: var(--theme-sidebar-bg);\n    border-right: 1px solid var(--theme-sidebar-border);\n    padding: var(--space-md) 0 var(--space-sm);\n  }\n\n  &__sidebar-header {\n    display: flex;\n    align-items: center;\n    gap: var(--space-sm);\n    padding: 0 var(--space-md) var(--space-md);\n    font-size: var(--font-size-sm);\n    font-weight: var(--font-weight-semibold);\n    color: var(--theme-text-tertiary);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n  }\n\n  &__nav {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 0 var(--space-xs);\n    gap: 1px;\n  }\n\n  &__nav-item {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--space-sm);\n    padding: 9px 10px;\n    border-radius: var(--radius-md);\n    border: none;\n    background: transparent;\n    color: var(--theme-text-secondary);\n    font-size: var(--font-size-base);\n    font-weight: var(--font-weight-medium);\n    cursor: pointer;\n    text-align: left;\n    transition: background 0.12s, color 0.12s;\n\n    svg {\n      flex-shrink: 0;\n      opacity: 0.7;\n      transition: opacity 0.12s;\n    }\n\n    &:hover {\n      background: var(--theme-sidebar-hover);\n      color: var(--theme-text-primary);\n\n      svg { opacity: 1; }\n    }\n\n    &--active {\n      background: var(--theme-selected-bg);\n      color: var(--theme-primary);\n      font-weight: var(--font-weight-semibold);\n\n      svg {\n        opacity: 1;\n        color: var(--theme-primary);\n      }\n\n      &:hover {\n        background: var(--theme-primary-soft-hover);\n      }\n    }\n  }\n\n  // ── Sidebar actions ────────────────────────────────────────────────────────\n\n  &__sidebar-actions {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-sm);\n    padding: var(--space-md) var(--space-md) var(--space-xs);\n    margin-top: var(--space-sm);\n    border-top: 1px solid var(--theme-border-soft);\n  }\n\n  &__action-btn {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--space-xs);\n    padding: 7px 12px;\n    border-radius: var(--radius-md);\n    border: 1px solid transparent;\n    background: transparent;\n    color: var(--theme-text-secondary);\n    font-size: var(--font-size-md);\n    font-weight: var(--font-weight-medium);\n    cursor: pointer;\n    transition: background 0.15s, color 0.15s, box-shadow 0.15s, transform 0.15s;\n    width: 100%;\n\n    &:hover:not(:disabled) {\n      background: var(--theme-sidebar-hover);\n      color: var(--theme-text-primary);\n    }\n\n    &--primary {\n      background: var(--theme-primary);\n      color: var(--theme-primary-contrast);\n      border-color: transparent;\n      box-shadow: 0 1px 3px rgba(37, 99, 235, 0.3), 0 1px 2px rgba(37, 99, 235, 0.2);\n      font-weight: var(--font-weight-semibold);\n\n      &:hover:not(:disabled) {\n        background: var(--theme-primary-hover);\n        box-shadow: 0 4px 12px rgba(37, 99, 235, 0.4), 0 2px 4px rgba(37, 99, 235, 0.25);\n        transform: translateY(-1px);\n      }\n\n      &:active {\n        transform: translateY(0);\n        box-shadow: 0 1px 3px rgba(37, 99, 235, 0.3);\n      }\n    }\n\n    &--loading,\n    &:disabled {\n      opacity: 0.55;\n      cursor: not-allowed;\n      transform: none !important;\n    }\n  }\n\n  &__import-result {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    padding: 4px var(--space-xs);\n    font-size: var(--font-size-xs);\n    color: var(--theme-success);\n    flex-wrap: wrap;\n  }\n\n  &__import-error {\n    padding: 4px var(--space-xs);\n    font-size: var(--font-size-xs);\n    color: var(--theme-danger);\n    word-break: break-word;\n  }\n\n  // ── List panel ─────────────────────────────────────────────────────────────\n\n  &__list-panel {\n    width: 280px;\n    flex-shrink: 0;\n    display: flex;\n    flex-direction: column;\n    border-right: 1px solid var(--theme-border-soft);\n    background: var(--theme-bg-primary);\n  }\n\n  &__search {\n    position: relative;\n    padding: var(--space-sm) var(--space-md);\n    border-bottom: 1px solid var(--theme-border-soft);\n  }\n\n  &__search-icon {\n    position: absolute;\n    left: calc(var(--space-md) + 8px);\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--theme-text-muted);\n    pointer-events: none;\n  }\n\n  // .contacts-app .contacts-app__search-input = (0,2,0) beats input[type] (0,1,1)\n  & &__search-input {\n    width: 100%;\n    padding: 6px 10px 6px 28px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--theme-border-primary);\n    background: var(--theme-bg-secondary);\n    color: var(--theme-text-primary);\n    font-size: var(--font-size-md);\n    outline: none;\n    transition: border-color 0.12s, box-shadow 0.12s;\n\n    &::placeholder {\n      color: var(--theme-text-placeholder);\n    }\n\n    &:focus {\n      border-color: var(--theme-border-focus);\n      background: var(--theme-bg-primary);\n      box-shadow: var(--theme-shadow-focus);\n    }\n  }\n\n  // ── Detail panel ───────────────────────────────────────────────────────────\n\n  &__detail-panel {\n    flex: 1;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    min-width: 0;\n  }\n\n  &__empty-detail {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: var(--space-md);\n    color: var(--theme-text-muted);\n    font-size: var(--font-size-base);\n  }\n}\n\n@keyframes contacts-spin {\n  to { transform: rotate(360deg); }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
